import type BaseEnumType from "@/app/services/baseEnumType";
import type { Maybe } from "@/components/utils/typeHelpers";

export class EnumDistributionStatus implements BaseEnumType {
  private static allValues: EnumDistributionStatus[] = []; // make sure this is top-most

  public static pending = new EnumDistributionStatus(
    1,
    "Pending",
    "enum_distribution_status_pending"
  );
  public static successful = new EnumDistributionStatus(
    2,
    "Successful",
    "enum_distribution_status_successful"
  );
  public static outForDelivery = new EnumDistributionStatus(
    3,
    "OutForDelivery",
    "enum_distribution_status_out_for_delivery"
  );
  public static exception = new EnumDistributionStatus(
    4,
    "Exception",
    "enum_distribution_status_exception"
  );
  public static failed = new EnumDistributionStatus(
    5,
    "Failed",
    "enum_distribution_status_failed"
  );
  public static hasNotes = new EnumDistributionStatus(
    6,
    "HasNotes",
    "enum_distribution_status_has_notes"
  );

  public key: number;
  public value: string;
  public translationKey?: string;

  private constructor(key: number, value: string, translationKey?: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDistributionStatus.allValues.push(this);
  }

  public equals(other: Maybe<EnumDistributionStatus>): boolean {
    return this.key === other?.key;
  }

  public isPending() {
    return this.equals(EnumDistributionStatus.pending);
  }
  public isSuccessful() {
    return this.equals(EnumDistributionStatus.successful);
  }
  public isOutForDelivery() {
    return this.equals(EnumDistributionStatus.outForDelivery);
  }
  public isException() {
    return this.equals(EnumDistributionStatus.exception);
  }
  public isFailed() {
    return this.equals(EnumDistributionStatus.failed);
  }
  public isHasNotes() {
    return this.equals(EnumDistributionStatus.hasNotes);
  }

  public static getValues(): EnumDistributionStatus[] {
    return EnumDistributionStatus.allValues;
  }

  public static getByKey(key: number): EnumDistributionStatus {
    const found = EnumDistributionStatus.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDistributionStatus - Key not found: ${key}`);
    }

    return found;
  }
}
